import { render, staticRenderFns } from "./MindoSvg.vue?vue&type=template&id=60db5360&"
import script from "./MindoSvg.vue?vue&type=script&lang=js&"
export * from "./MindoSvg.vue?vue&type=script&lang=js&"
import style0 from "./MindoSvg.vue?vue&type=style&index=0&id=60db5360&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports